import { UserOrderProductRow } from "../components/account/UserOrderProductRow"
import { CustomButton } from "../components/global/CustomButton"
import { useParams } from "react-router-dom"
import { useContext, useEffect, useState } from "react"
import { UserContext } from "../contexts/UserContext"
import "./userOrderDetails.css"

export function UserOrderDetails() {
    const { id } = useParams()

    const userContextData = useContext(UserContext)
    const { user, token, dispatch } = userContextData

    const [order, setOrder] = useState(null)

    const [day, setDay] = useState(null)
    const [month, setMonth] = useState(null)
    const [year, setYear] = useState(null)

    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]

    useEffect(() => {
        if (user) {
            const findOrder = user.orders.find(e => e.orderId === id)
            setOrder(findOrder)
        }
    }, [user])

    useEffect(() => {
        if(order) {
            const joinDateSplits = order.createdAt.split("-")
    
            setDay(joinDateSplits[2].slice(0, 2))
            setMonth(months[parseInt(joinDateSplits[1]) - 1])
            setYear(joinDateSplits[0])
        }
    }, [order])

    return (
        <div className="user-order">
            <h4 className="primary-text mb-5">Order Details</h4>

            {
                order && (
                    <>
                        <div className="fs-5 mb-2 status">
                            Order ID: {order.orderId}
                            <span className={"p-2 ms-5 rounded-1 order-" + (order.status.toLowerCase())}>
                                {order.status}
                            </span>
                        </div>
                        <div className="fs-5">
                            Placed on: <span className="primary-text">
                                {month + " " + day + " " + year}
                            </span>
                        </div>
                        <div className="fs-5">
                            Payment Method: <span className="primary-text">{order.paymentMethod}</span>
                        </div>
                        <div className="fs-5">
                            Total Amount: <span className="primary-text">${order.totalAmount}</span>
                        </div>
                    </>
                )
            }

            <div className="mt-5 user-order-wrapper">
                <table className="user-order-products-table mt-1 mb-4">
                    <tbody>
                        <tr className="table-header">
                            <td>Product</td>
                            <td>Quantity</td>
                            <td>Price</td>
                        </tr>
                    </tbody>
                </table>

                {
                    order && order.products.map((e, i) => (
                        <UserOrderProductRow key={i} product={e} />
                    ))
                }
            </div>
            <div className="d-flex justify-content-end">
                <CustomButton
                    color="primary"
                    text="Cancel Order"
                />
            </div>
        </div>
    )
}